

<div class="seperator"></div>
<div class="title" mat-dialog-title>Select Xero Tenant</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">You can select multiple tenants from the below</div>
        <mat-form-field appearance="outline" class="form-field">
            <mat-label>Xero Tenants</mat-label>
                <mat-select multiple [formControl]="selectedTenantIds">
                    <mat-option *ngFor="let tenant of tenants" [value]="tenant.id">
                        {{tenant.name}}
                    </mat-option>
                </mat-select>
        </mat-form-field>
    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()">
            Connect Data Source
        </button>
    </div>
</div>